"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var react_1 = __importDefault(require("react"));
var react_switch_1 = __importDefault(require("react-switch"));
var styled_components_1 = __importStar(require("styled-components"));
var utils_1 = require("../../../utils");
var StyledReactSwitch = styled_components_1.default(function (_a) {
    var isSmall = _a.isSmall, rest = __rest(_a, ["isSmall"]);
    return react_1.default.createElement(react_switch_1.default, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    .react-switch-handle {\n        top: ", "px !important;\n        border: solid 1px ", " !important;\n        background: ", " !important;\n\n        ", "\n\n        ", "\n    }\n"], ["\n    .react-switch-handle {\n        top: ", "px !important;\n        border: solid 1px ", " !important;\n        background: ", " !important;\n\n        ",
    "\n\n        ",
    "\n    }\n"])), function (props) { return (props.isSmall ? 2 : 3); }, function (props) { return props.theme.TYPE_WHITE; }, function (props) { return props.theme.TYPE_WHITE; }, function (props) {
    return props.checked && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                transform: ", ";\n            "], ["\n                transform: ",
        ";\n            "])), props.isSmall
        ? 'translateX(16px) !important'
        : 'translateX(21px) !important');
}, function (props) {
    return !props.checked && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                transform: ", ";\n            "], ["\n                transform: ",
        ";\n            "])), props.isSmall
        ? 'translateX(2px) !important'
        : 'translateX(3px) !important');
});
var Wrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var Switch = function (_a) {
    var onChange = _a.onChange, isDisabled = _a.isDisabled, isSmall = _a.isSmall, dataTest = _a.dataTest, checked = _a.checked, rest = __rest(_a, ["onChange", "isDisabled", "isSmall", "dataTest", "checked"]);
    var theme = utils_1.useTheme();
    return (react_1.default.createElement(Wrapper, { "data-test": dataTest },
        react_1.default.createElement(StyledReactSwitch, __assign({ checked: checked, disabled: isDisabled, onChange: onChange, onColor: theme.BG_GREEN, checkedIcon: false, uncheckedIcon: false, offColor: theme.STROKE_GREY, color: theme.BG_GREEN, isSmall: isSmall, width: isSmall ? 32 : 42, height: isSmall ? 18 : 24, handleDiameter: isSmall ? 14 : 18, boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)", activeBoxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.8)" }, rest))));
};
exports.Switch = Switch;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
